import React from 'react';
import Login from './Login';

const Signup = (props) => <Login asSignupVariant {...props} />;

export default Signup;
